// extracted by mini-css-extract-plugin
export default {"settings":"newsOptions_settings__wTJoI","checkBoxes":"newsOptions_checkBoxes__U5Xpd","title":"newsOptions_title__PR4Nj","items":"newsOptions_items__dGV95"};